import type {
  MeasurementGroup,
  MeasurementGroupCreate,
  MeasurementGroupField,
  MeasurementGroupFieldCreate,
  MeasurementGroupFieldUpdate,
  MeasurementGroupWithFields,
  MeasurementTemplate,
} from "@/types/measurement";

import { requestData } from "@/api/api-config";

export async function listMeasurementGroups(): Promise<
  MeasurementGroupWithFields[] | null
> {
  return await requestData<MeasurementGroupWithFields[]>(
    "admin/measurement-groups",
    "get",
  );
}

export async function createMeasurementGroup(
  data: MeasurementGroupCreate,
): Promise<MeasurementGroup | null> {
  return await requestData<MeasurementGroup>(
    "admin/measurement-groups",
    "post",
    {
      json: data,
    },
  );
}

export async function updateMeasurementGroup(
  groupId: string,
  data: Partial<MeasurementGroupCreate>,
): Promise<MeasurementGroup | null> {
  return await requestData<MeasurementGroup>(
    `admin/measurement-groups/${groupId}`,
    "put",
    { json: data },
  );
}

export async function archiveMeasurementGroup(groupId: string): Promise<void> {
  await requestData(`admin/measurement-groups/${groupId}`, "delete");
}

export async function addFieldsToGroup(
  groupId: string,
  fields: MeasurementGroupFieldCreate[],
): Promise<MeasurementGroupField[] | null> {
  return await requestData<MeasurementGroupField[]>(
    `admin/measurement-groups/${groupId}/fields`,
    "post",
    { json: fields },
  );
}

export async function updateGroupField(
  groupId: string,
  fieldId: string,
  data: MeasurementGroupFieldUpdate,
): Promise<MeasurementGroupField | null> {
  return await requestData<MeasurementGroupField>(
    `admin/measurement-groups/${groupId}/fields/${fieldId}`,
    "put",
    { json: data },
  );
}

export async function removeFieldFromGroup(
  groupId: string,
  fieldId: string,
): Promise<void> {
  await requestData(
    `admin/measurement-groups/${groupId}/fields/${fieldId}`,
    "delete",
  );
}

export async function removeChildGroupFromGroup(
  groupId: string,
  childGroupId: string,
): Promise<void> {
  await requestData(
    `admin/measurement-groups/${groupId}/child-groups/${childGroupId}`,
    "delete",
  );
}

export async function createFromTemplate(
  templateName: string,
): Promise<MeasurementGroupWithFields[] | null> {
  return await requestData<MeasurementGroupWithFields[]>(
    "admin/measurement-groups/from-template",
    "post",
    { json: { templateName } },
  );
}

export async function listTemplates(): Promise<MeasurementTemplate[] | null> {
  return await requestData<MeasurementTemplate[]>(
    "admin/measurement-groups/templates",
    "get",
  );
}
